import * as actionTypes from "./actionTypes";
import * as commonActionTypes from "../shared/commonActionTypes";
import * as saveFormDataActions from "../components/saveFormData/actionTypes";

const initialState = {
  loading: false,
  error: null,
  fields: [],
  isFieldsChanged: false
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FORM_FIELDS_REQUEST:
      return { loading: true, error: null, fields: [], isFieldsChanged: false };

    case actionTypes.FORM_FIELDS_FAILURE:
      return {
        loading: false,
        error: action.error,
        fields: [],
        isFieldsChanged: false
      };

    case actionTypes.FORM_FIELDS_SUCCESS:
      return {
        loading: false,
        error: null,
        fields: action.response,
        isFieldsChanged: false
      };
    case actionTypes.FORM_FIELD_VALUE_CHANGED:
      const newFields = state.fields.map(el => {
        if (el.elementId === action.elementId) {
          return Object.assign({}, el, { value: action.value });
        }
        return el;
      });
      return {
        ...state,
        fields: newFields,
        isFieldsChanged: true
      };
    case actionTypes.FORM_FIELD_VALUE_RESET:
    case saveFormDataActions.SAVE_FORM_DATA_SUCCESS:
      return { ...state, isFieldsChanged: false };

    case commonActionTypes.LOGOUT:
    case commonActionTypes.SET_CONTEXT:
    case commonActionTypes.SET_MATTER:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
